export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

export const ENVIRONMENTS = Object.freeze({
  development: "development",
  devAws: "dev-aws",
  test: "test",
  demo: "demo",
  production: "production",
});

export const isProduction = () => {
  return APP_ENVIRONMENT === ENVIRONMENTS.production;
};

export const isDevelopment = () => {
  return APP_ENVIRONMENT === ENVIRONMENTS.development;
};

export const isTest = () => {
  return APP_ENVIRONMENT === ENVIRONMENTS.test;
};

export const isDemo = () => {
  return APP_ENVIRONMENT === ENVIRONMENTS.demo;
};